import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/_services/generic.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DossierCorrespondanceStatusModel } from "./models/dossierCorrespondanceStatus.model";
import { environment } from 'environments/environment';
import { FaxModel } from "app/_shared/correspondance-module/models/faxModel";

@Injectable({
    providedIn: 'root',
})

export class CorrespondanceService extends GenericService<any> {
    constructor(private http: HttpClient) {
        super(http,'/Correspondance/',environment.Services.AlphaURLSlot2)
    } 
    
    public getCorrespondanceTypes () : Observable<any[]> {
        return this._http.get(this.rootUrl +"/Correspondance/GetActionTypes", this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public getCorrespondanceByStatus (dossierCorrespondanceStatus: DossierCorrespondanceStatusModel) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/Correspondance/GetByStatus/", dossierCorrespondanceStatus, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public sendCorrespondance (correspondance) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/Correspondance/SendCorrespondance/",correspondance, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public reSendCorrespondance (correspondance) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/DossierAction/ResendMessage/",correspondance, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public getAttachmentData (documentId) : Observable<any[]> {
        let commonUrl = environment.apiProtocol + environment.Services.CommonBaseURL
        return this._http.get(commonUrl +"/document/"+documentId, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public getCorrespondanceAttachments (corespondanceId) : Observable<any[]> {
        return this._http.get(this.rootUrl +"/Correspondance/GetCorrespondanceAttachments/"+corespondanceId, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public uploadOutlookEmail (outlookEmail) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/Correspondance/UploadOutlookEmail/", outlookEmail, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public sendFax (faxData: FaxModel) : Observable<any[]> {
        return this._http.post(this.rootUrl +"/Correspondance/sendFax/", faxData, this.prepareHeader()).pipe(map(res => res as any[]))
    }

    public sendSms (correspondance) : Observable<any> {
        return this._http.post(this.rootUrl +"/Correspondance/sendSms/", correspondance, this.prepareHeader()).pipe(map(res => res as any))
    }

    public getSmsBody (attachmentId): Observable<any>  {
        return this._http.get(this.rootUrl +"/Correspondance/getSmsBody/"+attachmentId, this.prepareHeader()).pipe(map(res => res as any))
    }

    public getSmsBodies(): Observable<any>{
        return this._http.get(this.rootUrl +"/Correspondance/getSmsBodies/", this.prepareHeader()).pipe(map(res => res as any))
    }
    public getSOSInternalEmails (partialName) : Observable<any> {
        return this._http.get(`${this.rootUrl}/Correspondance/sosEmail/${partialName}`, this.prepareHeader()).pipe(map(res => res as any))
    }

}